// Pro app shell. Property show pages load pro_property.jsx separately.
import { startOnePatchRum } from "../onepatch_rum"
import "@hotwired/turbo-rails"
import Trix from "trix"
import "trix/dist/trix.css"
import { configureListingTrix } from "@pro/listing_trix_config"

configureListingTrix()

import "../pro_controllers"

// Browser telemetry. No-ops unless the server rendered the onepatch-rum meta tag.
startOnePatchRum()
